<template>
  <div class="pl-10 pr-0 sm:px-8 py-3 flex flex-col w-full h-full">
    <h1 class="mb-3 text-sm text-white font-bold">Management Izin Akses</h1>
    <div
      v-if="selectedUserRole === null"
      class="Scroll pr-1 sm:pr-5 w-full h-full overflow-hidden">
      <div class="flex flex-row w-full mb-3 gap-3">
        <form
          @submit.prevent="searchUser()"
          class="relative flex flex-grow">
          <input
            v-model="roleName"
            class="px-3 py-3 flex-grow h-8 form-input rounded-md text-xs"
            type="text"
            placeholder="cari izin akses ...">
          <button
            @click="searchUserRole()"
            class="absolute px-3 py-3 flex items-center right-0 top-0 h-8"
            type="button">
            <i class="material-icons text-lg text-gray-500">search</i>
          </button>
        </form>
        <button
          @click="addUserRole()"
          class="flex flex-row justify-center items-center p-2 bg-green-500 rounded-md">
          <i class="material-icons text-xs text-white mr-1">add</i>
          <span class="text-xs text-white">Tambah Izin</span>
        </button>
      </div>
      <div class="flex flex-col sm:flex-row sm:flex-wrap mb-3">
        <div
          v-for="role in userRoles.data"
          :key="role.id"
          class="flex flex-col p-3 sm:w-2/4 lg:w-1/3 bg-gray-400 rounded border border-gray-500">
          <span class="text-sm text-white">{{ role.role_name }}</span>
          <div class="flex gap-1 justify-end items-center">
            <button
              @click="editUserRole(role)"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-green-500"
              type="button"
              title="Edit Grup">
              <i class="material-icons text-sm">edit</i>
            </button>
            <button
              @click="deleteUserRole(role)"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-red-500"
              type="button"
              title="Hapus Grup">
              <i class="material-icons text-sm">delete</i>
            </button>
          </div>
        </div>
      </div>
      <Pagination
        class="justify-end items-end"
        :offset="userRoles.offset"
        :limit="userRoles.limit"
        :total="userRoles.total"
        :handler="changePage" />
    </div>
    <div
      v-if="selectedUserRole"
      class="flex flex-col mb-3">
      <button
        @click="selectedUserRole = null"
        class="flex flex-row justify-center items-center px-2 py-1 w-44 bg-gray-400 rounded-md">
        <i class="material-icons text-lg text-white mr-1">chevron_left</i>
        <span class="text-xs text-white">Kembali Ke Izin Akses</span>
      </button>
    </div>
    <div
      v-if="selectedUserRole"
      class="w-full h-full overflow-hidden">
      <FormUserRole :roleId="selectedUserRole ? selectedUserRole.id : null" />
    </div>
    <PopupConfirm ref="PopupUserRoles" />
    <PopupMessage :message="message" :confirm="{ success: confirmSuccess }" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormUserRole from './FormUserRole.vue'
import Pagination from './Pagination.vue'
import PopupConfirm from './PopupConfirm.vue'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'TableUserRoles',
  data: () => ({
    roleName: null,
    selectedUserRole: null,
    deletedUserRole: null
  }),
  computed: {
    ...mapGetters([
      'message',
      'userRoles'
    ])
  },
  components: {
    FormUserRole,
    Pagination,
    PopupConfirm,
    PopupMessage
  },
  methods: {
    ...mapActions([
      'loadUserRoles',
      'toDeleteUserRole'
    ]),
    addUserRole: function () {
      this.selectedUserRole = true
    },
    editUserRole: function (role) {
      this.selectedUserRole = role
    },
    deleteUserRole: function (role) {
      this.deletedUserRole = role

      this.$refs.PopupUserRoles.show(
        `Apakah anda yakin ingin menghapus grup pengguna "${role.role_name}"?`,
        { handler: this.confirmDeleteRole }
      )
    },
    confirmDeleteRole: async function () {
      await this.toDeleteUserRole(this.deletedUserRole.id)
    },
    confirmSuccess: async function () {
      if (this.selectedUserRole) {
        this.selectedUserRole = null
      }

      await this.loadUserRoles()
    },
    changePage: async function (page) {
      await this.loadUserRoles({
        offset: page.offset,
        limit: page.limit
      })
    },
    searchUser: async function () {
      await this.loadUserRoles({
        name: this.roleName
      })
    }
  },
  mounted: async function () {
    await this.loadUserRoles()
  }
}
</script>
